import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { create } from './ladda';
import { COLORS, SIZES, STYLES } from './constants';

var isUndefined = value => typeof value === 'undefined';

var MAPPED_PROPS = {
  color: 'data-color',
  size: 'data-size',
  style: 'data-style',
  spinnerSize: 'data-spinner-size',
  spinnerColor: 'data-spinner-color',
  spinnerLines: 'data-spinner-lines'
};

var mapLegacyProps = props => Object.keys(props).reduce((mappedProps, key) => {
  var finalKey = MAPPED_PROPS[key] || key;
  mappedProps[finalKey] = props[key];
  return mappedProps;
}, {});

export default class LaddaButton extends React.Component {
  constructor() {
    super();
    this.buttonRef = React.createRef();
  }

  componentDidMount() {
    var {
      loading,
      progress
    } = this.props;
    this.laddaInstance = create(this.buttonRef.current);

    if (loading) {
      this.laddaInstance.start();
    }

    if (!isUndefined(progress)) {
      this.laddaInstance.setProgress(progress);
    }
  }

  componentDidUpdate(prevProps) {
    var {
      loading,
      progress
    } = this.props;

    if (prevProps.loading !== loading) {
      if (loading) {
        this.laddaInstance.start();
      } else {
        this.laddaInstance.stop();
      }
    }

    if (prevProps.progress !== progress) {
      this.laddaInstance.setProgress(progress);
    }
  }

  componentWillUnmount() {
    this.laddaInstance.remove();
  }

  render() {
    var _this$props = this.props,
        {
      className,
      children,
      disabled,
      loading,
      progress
    } = _this$props,
        otherProps = _objectWithoutProperties(_this$props, ["className", "children", "disabled", "loading", "progress"]);

    return React.createElement("button", Object.assign({}, mapLegacyProps(otherProps), {
      className: "ladda-button ".concat(className || ''),
      ref: this.buttonRef,
      disabled: disabled || loading
    }), React.createElement("span", {
      className: "ladda-label"
    }, children));
  }

}